module.exports = __webpack_public_path__ + "img/S.b4dae897.jpg";